import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { SimpleSection } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Update course lectures order
 * @param course_id
 * @param version
 * @param sections
 */
const updateCourseLecturesOrder = (
  course_id: string,
  version: number,
  sections: SimpleSection[]
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/sections/all/lectures'
    const data = { sections }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.put(URL, data, config)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject('Error updating Section Items: ' + err)
      })
  })
}

export default updateCourseLecturesOrder
